//
//
//

export default {
	name: 'logoBlueMobile',
}
